import 'whatwg-fetch';
import { Uppy } from '@uppy/core';
import AwsS3 from '@uppy/aws-s3';
import { Promise } from 'es6-promise';

class PasteImageUploader {
  constructor() {}

  upload(file) {
    this.uppy = this.createUppyInstance();

    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;

      this.uppy.addFile({
        source: 'file input',
        name: file.name,
        type: file.type,
        data: file
      });
    });
  }

  createUppyInstance() {
    return new Uppy()
      .use(AwsS3, { endpoint: '/store/' })
      .on('file-added', (file) => { this.uppy.upload(); })
      .on('upload-success', (uploadResult, uploadResponse) => {
        this.resolve(uploadResponse.uploadURL);
      })
      .on('error', (result, response) => {
        this.reject(result, response);
      })
      .on('upload-error', (result, response) => {
        this.reject(result, response);
      });
  }
}

export default PasteImageUploader;
